import { Icon } from "@iconify/react";
import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import Paggination from "../Paggination";
import { debounce } from "lodash";
import { MdOutlineAddCard } from "react-icons/md";
import AddBrokerModal from "../model/AddBrokerModal";
import LedgerModal from "../Accounts/LedgerModal";
import { formatCurrency, formatDateFull } from "../../utils/helper";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../constants/pageSizeOptions";
import SearchableSelect from "../Common/SearchableSelect";

const BrokerLayer = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: DEFAULT_PAGE_SIZE,
    search: "",
    isPagination: true,
    status: ""
  });
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { AsyncGetApiCall, AsyncPatchApiCall } = useApi();

  const fetchBrokers = async () => {
    setLoading(true);
    const result = await AsyncGetApiCall(`/broker`, query);

    if (result?.errors) {
      toast.error(result.errors[0]);
    } else if (result?.success) {
      setData(result);
    }
    setLoading(false);
  };

  console.log("data", data)

  useEffect(() => {
    fetchBrokers();
  }, [query, showModal]);

  const debouncedSearch = useCallback(
    debounce((value) => {
      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    }, 500),
    [],
  );

  const handleSearchChange = (e) => {
    debouncedSearch(e.target.value);
  };

  const handleEditBroker = (broker) => {
    setEditData(broker);
    setShowModal(true);
  };

  // const deleteBroker = async (id) => {
  //   if (window.confirm("Are you sure you want to delete this broker?")) {
  //     setLoading(true);
  //     const result = await AsyncDeleteApiCall(`/broker/${id}`);

  //     if (result.errors) {
  //       toast.error(result.errors[0]);
  //     } else if (result.success) {
  //       toast.success(`Broker deleted successfully`);
  //       fetchBrokers();
  //     }
  //     setLoading(false);
  //   }
  // };

  const toggleStatus = async (id) => {
    const { isConfirmed } = await Swal.fire({
      title: "Change Status?",
      text: `${data?.data?.find(b => b._id === id)?.status ? "Deactivate" : "Activate"} this broker?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2352c3",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Change it!",
      customClass: { popup: "swal-sm" },
    });

    if (!isConfirmed) {
      return;
    }
    setLoading(true);
    const result = await AsyncPatchApiCall(`/broker/toggle-status/${id}`);

    if (result.errors) {
      toast.error(result.errors[0]);
    } else if (result.success) {
      toast.success(`Status updated successfully`);
      fetchBrokers();
    }
    setLoading(false);
  };

  const handleLedgerClick = (user) => {
    setSelectedAccount({
      name: user.name,
      id: user.loginId,
      dbId: user._id,
    });
    setIsModalOpen(true);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center justify-content-between gap-3 w-100">
            <div className="d-flex align-items-center gap-3">
              <span className="text-md fw-medium text-secondary-light mb-0">
                Show
              </span>
              <div style={{ minWidth: "92px" }}>
                <SearchableSelect
                  placeholder="Show"
                  value={String(query.limitVal)}
                  showSearch={false}
                  onChange={(e) => {
                    const value = parseInt(e.target.value, 10);
                    setQuery((prev) => ({
                      ...prev,
                      limitVal: value,
                      pageNo: 1,
                    }));
                  }}
                  options={PAGE_SIZE_OPTIONS.map((n) => ({
                    label: String(n),
                    value: String(n),
                  }))}
                />
              </div>
              <form
                className="navbar-search"
                onSubmit={(e) => e.preventDefault()}
              >
                <input
                  type="text"
                  className="bg-base h-40-px w-400-px"
                  placeholder="Search by name, login-ID"
                  onChange={handleSearchChange}
                  name="search"
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
              <span className="text-md fw-medium text-secondary-light mb-0">
                Status
              </span>
              <select
                name="status"
                id="status"
                className="form-select h-40-px"
                value={query.status}
                onChange={(e) => {
                  const value = e.target.value;
                  setQuery((prev) => ({ ...prev, status: value, pageNo: 1 }));
                }}
              >
                <option value="">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-primary-600 radius-8 px-17 py-9 d-flex align-items-center gap-2"
                onClick={() => {
                  setEditData(null);
                  setShowModal(true);
                }}
                disabled={loading}
              >
                <MdOutlineAddCard className="text-xl" />
                Add Broker
              </button>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Login ID</th>
                  <th>Current Balance</th>
                  <th>Created By</th>
                  <th>Remarks</th>
                  <th>Created At</th>
                  <th>Status</th>
                  <th style={{ textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data.length > 0 ? (
                  data?.data.map((broker, index) => (
                    <tr key={broker._id}>
                      <td>{(query.pageNo - 1) * query.limitVal + index + 1}</td>
                      <td>{broker.name}</td>
                      <td>{broker.loginId}</td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="text-md fw-medium" title="Real Balance">
                            {formatCurrency(broker?.currentBalance) || "-"}
                          </span>
                          {(broker?.unsettledPnl !== 0 && broker?.unsettledPnl !== undefined) && (
                            <span 
                              className={`text-xs fw-semibold ${broker?.unsettledPnl >= 0 ? "text-success-600" : "text-danger-600"}`} 
                              title="Unsettled Amount (Running PnL + Brokerage)"
                            >
                              Unsettled: {formatCurrency(broker?.unsettledPnl)}
                            </span>
                          )}
                        </div>
                      </td>
                      <td>{broker?.createdByModel === "Admin" ? broker?.createdByModel : `${broker?.createdById?.masterName || broker?.createdById?.name} (${broker?.createdById?.loginId}) (${broker?.createdByModel}) ` || "-"}</td>
                      <td>{broker.remarks || "-"}</td>
                      <td>{formatDateFull(broker.createdAt)}</td>
                      <td>
                        <span
                          className={`${broker.status
                            ? "bg-success-focus text-success-600"
                            : "bg-danger-focus text-danger-600"
                            } border px-16 py-4 radius-4 fw-medium text-sm cursor-pointer`}
                          onClick={() => toggleStatus(broker._id)}
                        >
                          {broker.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="ledger-action-btn w-40-px h-40-px"
                            onClick={() => handleLedgerClick(broker)}
                            aria-label="View ledger"
                          >
                            <Icon icon="tabler:file-text" className="icon" />
                          </button>
                          <button
                            type="button"
                            className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => handleEditBroker(broker)}
                          >
                            <Icon icon="lucide:edit" className="menu-icon" />
                          </button>
                          {/* <button
                            type="button"
                            className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => deleteBroker(broker._id)}
                          >
                            <Icon
                              icon="fluent:delete-24-regular"
                              className="menu-icon"
                            />
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No brokers found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.meta?.total || 0}
            totalPages={data?.meta?.totalPages || 0}
            currentPage={data?.meta?.page || 1}
            setPageNo={(page) =>
              setQuery((prev) => ({ ...prev, pageNo: page }))
            }
            startFrom={((data?.meta?.page || 1) - 1) * query.limitVal + 1}
            endTo={
              ((data?.meta?.page || 1) - 1) * query.limitVal +
              (data?.data?.length || 0)
            }
          />
          <AddBrokerModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            loading={loading}
            editData={editData}
            onSuccess={fetchBrokers}
          />
          {selectedAccount && (
            <LedgerModal
              show={!!selectedAccount && isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setSelectedAccount(null);
              }}
              accountName={selectedAccount?.name ?? ""}
              accountId={selectedAccount?.id ?? ""}
              accountDbId={selectedAccount?.dbId}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BrokerLayer;
